import { jsonPost, get } from './public'
import axios from 'axios';

export const login = function (params) {
  return jsonPost('/sys/login', params)
}

// 手机号登录接口
export function phoneLogin(params) {
  return jsonPost('/sys/phoneLogin', params)
}

// 获取购物车总数
export function getCount(params) {
  return get('/cart/getCount', params)
}

export function getSmsCaptcha(params) {
  return jsonPost('/sys/sms', params)
}

export function logout(logoutToken) {
  return axios({
    url: '/sys/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Access-Token': logoutToken
    }
  })
}